export const theme = {
  colors: {
    blackColor: "#000",
    blackColorBlur: "rgba(0,0,0,0.85)",
    bgColor: "#f6fcff",
    buttonColor: "#00b4db",
  },
  fonts: {
    family: {
      default: "'Open Sans', sans-serif",
      secondary: "'Arial', 'Helvetica', sans-serif",
    },
  },
};
